import Box from '@mui/material/Box';
import type { SxProps, Theme } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';

import VatikaLogo from '../../assets/icons/vatikaLogo.png';

import { VATIKA_LOGO_WIDTH } from './header.constants';

const badgeSx: SxProps<Theme> = {
  width: VATIKA_LOGO_WIDTH,
  marginInlineStart: 2,
  p: 1,
  bgcolor: 'common.white',
  borderRadius: 0.5,
};

const logoSx: SxProps<Theme> = { display: 'block', width: 1 };

export const VatikaBadge = (): JSX.Element => {
  const { t } = useTranslation();

  return (
    <Box sx={badgeSx}>
      <Box component="img" src={VatikaLogo} alt={t('header.vatikaLogoAlt', 'Vatika Logo')} sx={logoSx} />
    </Box>
  );
};
